export default {
    ASSET_BASE_URL: "https://static-1255466169.cos.ap-guangzhou.myqcloud.com/tui/assets",
    AMAP_URL: "https://webapi.amap.com/maps?v=1.4.15&key=80d3042c3851a5dc16a89dfccc1efa4e&plugin=Map3D,AMap.DistrictLayer,AMap.Scale,AMap.ToolBar,AMap.MarkerClusterer,AMap.Geocoder,AMap.Autocomplete,AMap.PlaceSearch,AMap.DistrictSearch",
    ECHART_URL: "https://jianli-static-1255466169.cos.ap-guangzhou.myqcloud.com/echarts.min.js",
    CITY_DATA: "https://static-1255466169.cos.ap-guangzhou.myqcloud.com/tui/assets/citys.js"
}